/**
 * ScoreCard - Displays quiz result score
 */
import { Trophy } from 'lucide-react';
import { LEVEL_LABELS } from '@/lib/api';

export default function ScoreCard({ correctCount, totalQuestions, percentCorrect, totalTimeMs, level }) {
  const isGoodScore = percentCorrect >= 75;

  return (
    <div className="glass-card rounded-2xl p-5 sm:p-8 text-center mb-4 sm:mb-6">
      <div className={`w-14 sm:w-20 h-14 sm:h-20 mx-auto rounded-full flex items-center justify-center mb-3 sm:mb-4 ${isGoodScore ? 'bg-[#10B981]/20' : 'bg-[#F59E0B]/20'}`}>
        <Trophy className={`w-7 sm:w-10 h-7 sm:h-10 ${isGoodScore ? 'text-[#10B981]' : 'text-[#F59E0B]'}`} />
      </div>
      <div className="inline-block px-2 sm:px-3 py-0.5 sm:py-1 rounded-full bg-white/5 text-[#9CA3AF] text-[10px] sm:text-xs font-mono mb-3 sm:mb-4">
        {LEVEL_LABELS[level]}
      </div>
      <h1 className="font-outfit font-extrabold text-3xl sm:text-5xl text-white mb-1 sm:mb-2" data-testid="result-score">
        {correctCount}/{totalQuestions}
      </h1>
      <p className="text-[#9CA3AF] text-base sm:text-lg mb-0.5 sm:mb-1">
        Prozent: <span className="text-white font-bold">{percentCorrect}%</span>
      </p>
      <p className="text-[#4B5563] text-xs sm:text-sm">
        Zeit: {(totalTimeMs / 1000).toFixed(1)}s
      </p>
    </div>
  );
}
